import { IconProps } from "models"

const RightWave: React.FC<IconProps> = ({
	className = "",
	style = null,
	width = "511",
	height = "793",
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 511 793"
			className={className}
			style={style}
			width={width}
			height={height}
			aria-hidden="true"
		>
			<g transform="translate(-1409 -287)">
				<g>
					<path
						d="M2527.961 119.543s-542.25 3.727-645.206 280.441S1722.306 812.34 1515.01 961.4s-114.987 418 338.573 344.216 826.949-32.686 826.949-32.686l14.16-1213.01Z"
						fill="rgba(27,20,100,0.03)"
					/>
					<path
						d="M2524.003 84.543s-568.772 6.573-626.213 349.511-248.404 433.012-411.245 591.971-117.257 318.375 347.071 244.589 846.58-32.686 846.58-32.686l14.5-1213.007Z"
						fill="rgba(27,20,100,0.09)"
					/>
				</g>
			</g>
		</svg>
	)
}

export default RightWave
